export { default as Spinner } from './spinner'



// WEBPACK FOOTER //
// ./src/components/organisms/spinner/index.ts